module.exports = __webpack_public_path__ + "static/media/GelBox.1d466478.svg";